<template>
  <!-- 音频 -->
  <div class="ctrl relative right-btn">
    <div class="btn-hover" @click.stop="startPlayOrPause">
      <i
        id="audioBtn"
        :class="
          loaded
            ? 'btns btns-audio0 inline-block'
            : 'btns btns-loading inline-block'
        "
      />

      <span class="absolute h-6 leading-none opacity-0 text-center tooltip-css">
        语音讲解
      </span>
    </div>
    <ul v-if="sourcesData" id="audioBar" class="absolute audio-lists">
      <li v-for="item in data" :key="item.id" :class="audioListClass(item)">
        <Player
          :ref="`${item.type}Ref`"
          :sources="[item.path_url]"
          :value="true"
          :data="item"
          :xhrWithCredentials="true"
          :loaded.sync="loaded"
          :loop="true"
        ></Player>
      </li>
      <i
        class="iconfont icon-close cursor-pointer absolute"
        aria-hidden="true"
        @click.stop="hiddenStyle"
      />
    </ul>
  </div>
</template>

<script>
import Player from '@/components/common/AudioPlayer'

export default {
  name: 'audio-bar',
  props: {
    showAudio: null,
    data: null,
    briefAudio: null,
    detailAudio: null
  },
  components: {
    Player
  },
  watch: {
    showAudio(val) {
      this.change(val === 'showAudio')
    },
    loaded(val) {
      if (!val) {
        return false
      }

      this.change(val)
    }
  },
  data() {
    return {
      hiddenAudio: null,
      seek: null,
      sourcesData: false,
      loaded: true
    }
  },
  methods: {
    // 控制音频的播放与暂停
    startPlayOrPause() {
      if (!this.sourcesData) {
        this.loaded = false
        this.sourcesData = this.data
      }
      // 显示/隐藏 音频
      if (this.hiddenAudio && this.$parent.showModal === 'showAudio') {
        this.change(true)
      } else {
        this.$parent.closeModals(
          'showAudio',
          !(this.$parent.showModal === 'showAudio')
        )
      }
    },
    change(newVal) {
      this.$nextTick(() => {
        let bar = document.getElementById('audioBar')
        // 如果点语音图标时，不默认自动播放第一条
        // hiddenAudio时，是按X关闭控件但 语音还继续播放时，此时控件出现要自动播放
        // newVal点播放按钮
        // hiddenAudio是点了X号关闭的
        if (!bar) {
          return
        }
        // // eslint-disable-next-line no-console
        // console.log({ newVal, hiddenAudio: this.hiddenAudio })
        if (this.showAudio !== 'showAudio' || (!newVal && !this.hiddenAudio)) {
          // showAudio为其他弹框 或 newVal=false hiddenAudio=false：保存播放进度 播放器active=false
          this.getSeek()
          bar.classList.remove('active')
        } else if (newVal && this.hiddenAudio) {
          // newVal=true hiddenAudio=true：播放器active 保存进度 且继续播放，hiddenAudio=false
          bar.classList.add('active')
          this.setSeek()
          this.getSeek()
          this.hiddenAudio = false
        } else if (!newVal && this.hiddenAudio) {
          // newVal=false hiddenAudio=true：播放器active 且继续播放，hiddenAudio=false
          bar.classList.add('active')
          this.getSeek()
          this.setSeek()
          this.hiddenAudio = false
        } else if (newVal && !this.hiddenAudio) {
          // newVal=true hiddenAudio=false：播放器active 设置进度但 不继续播放
          this.setSeek()
          bar.classList.add('active')
        }
      })
    },
    setSeek() {
      // // eslint-disable-next-line no-console
      // console.log('设置进度/接着播放')
      let obj = this.$refs
      if (obj) {
        let timer = setTimeout(() => {
          if (this.seek) {
            this.seek.forEach(item => {
              obj[item.name][0].setSeek(item.value)
              if (this.hiddenAudio) {
                if (item.playing) {
                  obj[item.name][0].play() // 自动播放有进度的那条
                }
              }
              // } else {
              //   obj[Object.keys(obj)[0]][0].play() // 自动播放第一条
            })
          }
          clearTimeout(timer)
        }, 100)
        this.hiddenAudio = false
      }
    },
    getSeek() {
      // // eslint-disable-next-line no-console
      // console.log('保存进度')
      let obj = this.$refs
      let el
      let emptyArr = []
      for (el in obj) {
        let seek = obj[el][0].seek
        let playing = obj[el][0].playing
        emptyArr.push({ name: el, value: seek, playing })
        // // eslint-disable-next-line no-console
        // console.log(emptyArr)
        if (seek > 0) {
          this.seek = JSON.parse(JSON.stringify(emptyArr))
        }
      }
    },
    hiddenStyle() {
      let bar = document.getElementById('audioBar')
      bar.classList.remove('active')
      this.getSeek()
      this.hiddenAudio = true
    },
    audioListClass(item) {
      let className = 'relative '
      if (item.type === 'detail') {
        className += 'detail-css'
      } else if (item.type === 'brief') {
        className += 'brief-css'
      } else {
        className += 'hidden'
      }

      return className
    }
  }
}
</script>
<style scoped lang="scss">
// 新
.audio-lists {
  top: 0;
  right: 82px;
  opacity: 0;
  > li {
    height: 34px;
    width: 220px;
    line-height: 32px;
    background-color: rgba(0, 0, 0, 0.7);
    margin-bottom: 3px;
  }
  &.active {
    transition: opacity 0.2s;
    -moz-transition: opacity 0.2s; /* Firefox 4 */
    -webkit-transition: opacity 0.2s; /* Safari 和 Chrome */
    -o-transition: opacity 0.2s; /* Opera */
    opacity: 1;
  }
}

.icon-close {
  width: 1rem;
  height: 1rem;
  line-height: 1rem;
  top: 0rem;
  right: -1rem;
  font-size: 0.6rem;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.7);
  &:hover {
    color: #979797;
  }
}
</style>
